// extracted by mini-css-extract-plugin
export var container = "_of-0";
export var dotAnimation = "_of-2";
export var dotsLoading = "_of-1";